import type { CloudGraphSpaceEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI: CloudGraphSpaceEntityAti[] = [
	'ati:cloud:graph:space',
];
